import { render, staticRenderFns } from "./ListThread.vue?vue&type=template&id=5396f2ad&scoped=true&"
import script from "./ListThread.vue?vue&type=script&lang=js&"
export * from "./ListThread.vue?vue&type=script&lang=js&"
import style0 from "./ListThread.vue?vue&type=style&index=0&id=5396f2ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396f2ad",
  null
  
)

export default component.exports